import "./style.css";
import * as THREE from "three";
// import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
// import * as dat from "dat.gui";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/dist/ScrollSmoother";
import { Physics2DPlugin } from "gsap/dist/Physics2DPlugin";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
// import { GSDevTools } from "gsap/dist/GSDevTools";
import { SplitText } from "gsap/dist/SplitText";
// import { TextPlugin } from "gsap/dist/TextPlugin";
import vShader from "./SHADERS/vertexShader.glsl.js";
import fShader from "./SHADERS/fragmentShader.glsl";
import vShader1 from "./SHADERS/SHADERS1/vertexShader1.glsl.js";
import fShader1 from "./SHADERS/SHADERS1/fragmentShader1.glsl";
import vShader3 from "./SHADERS/SHADERS2/vertexShader3.glsl.js";
import fShader3 from "./SHADERS/SHADERS2/fragmentShader3.glsl";
import vShader4 from "./SHADERS/PLASTIC/vertexShader4.glsl.js";
import fShader4 from "./SHADERS/PLASTIC/fragmentShader4.glsl";
import vShader5 from "./SHADERS/CIRCUIT/vertexShader5.glsl.js";
import fShader5 from "./SHADERS/CIRCUIT/fragmentShader5.glsl";
import vShader6 from "./SHADERS/CALEI/vertexShader6.glsl.js";
import fShader6 from "./SHADERS/CALEI/fragmentShader6.glsl";

gsap.registerPlugin(
  ScrollTrigger,
  ScrollSmoother,
  SplitText,
  Physics2DPlugin,
  ScrollToPlugin
);

//progress circle

gsap.set("#circ-cont #svg circle", {
  strokeDashoffset: 753.98,
});

//to avoid fouc in this componet:
gsap.set(".warpAmount", { autoAlpha: 0 });

//pilot buttons
const autoPilotBTN = document.querySelector(".autoPilotBTN");
const stopAutoBTN = document.querySelector(".stopAutoBTN");
const restartBTN = document.querySelector(".restartBTN");
document
  .querySelector(".contact")
  .addEventListener("click", () => window.open("https://www.pabloyorio.com"));

let tween;
const totalDuration = 60;
const pageMaxOffset = 23380;
//calculates scroll duration dinamically depending on current position for constant speed
const auto = () => {
  autoPilotBTN.style.visibility = "hidden";
  stopAutoBTN.style.visibility = "visible";

  tween = gsap.timeline().to(window, {
    duration: () =>
      (totalDuration / pageMaxOffset) * (pageMaxOffset - window.pageYOffset),
    scrollTo: {
      y: "max",
      autoKill: true,
      onAutoKill: myAutoKillFunction,
    },
  });
};

function myAutoKillFunction() {
  stopAutoBTN.style.visibility = "hidden";
  autoPilotBTN.style.visibility = "visible";
}

const killAuto = () => {
  stopAutoBTN.style.visibility = "hidden";
  autoPilotBTN.style.visibility = "visible";
  tween.kill();
};

autoPilotBTN.addEventListener("click", auto);
stopAutoBTN.addEventListener("click", killAuto);

restartBTN.addEventListener("click", () => {
  //scrolls to the top using scrollTo:
  gsap
    .timeline()
    .to(".mask", { autoAlpha: 1 })
    .to(window, { scrollTo: 0, onComplete: () => location.reload() }, 0.3);
  // .to(".mask", { autoAlpha: 0,  }, 2.4);

  //  refresh the page
});

//TEXT ANIMATIONS

//SECTION 1

gsap.set("body", { autoAlpha: 1 }); // avoid fouc

//sets the slide in and out text effects:
gsap.registerEffect({
  name: "slideInUp",
  extendTimeline: true,
  defaults: {
    y: 0,
    x: 0,
    duration: 1,
    ease: "power1",
  },
  effect: (targets, config) => {
    let tl = gsap.timeline();
    tl.from(targets, {
      duration: config.duration,
      ease: config.ease,
      x: config.x,
      y: config.y,
      stagger: {
        each: 0.03,
        ease: "power1",
      },
    });
    tl.from(
      targets,
      {
        duration: config.duration,
        opacity: 0,
        ease: "none",
        stagger: {
          each: 0.03,
          ease: "power2",
        },
      },
      0
    );
    return tl;
  },
});

gsap.registerEffect({
  name: "slideOutUp",
  extendTimeline: true,
  defaults: {
    x: 0,
    y: 0,
    duration: 0.5,
    ease: "power1.in",
  },
  effect: (targets, config) => {
    let tl = gsap.timeline();
    tl.to(targets, {
      duration: config.duration,
      x: config.x,
      y: config.y,
      ease: "power1.in",
      stagger: {
        each: 0.01,
        ease: "power1",
      },
    });
    tl.to(
      targets,
      {
        duration: config.duration,
        opacity: 0,
        ease: "none",
        stagger: {
          each: 0.01,
          ease: "power2",
        },
      },
      0
    );
    return tl;
  },
});

//burn effect:

gsap.registerEffect({
  name: "burnIn",
  extendTimeline: true,
  defaults: {
    y: 0,
    x: 0,
    duration: 0.5,
    ease: "none",
  },
  effect: (targets, config) => {
    gsap.set(targets, { filter: "blur(0px) brightness(1)" });
    let tl = gsap.timeline();
    tl.from(targets, {
      filter: "blur(20px) brightness(8)",
      scale: 0.8,
      rotation: -10,
      duration: config.duration,
      ease: config.ease,
      x: config.x,
      y: config.y,
      stagger: {
        each: 0.02,
        ease: "none",
        from: "end",
      },
    });
    tl.from(
      targets,
      {
        duration: 0.1,
        opacity: 0,
        ease: "none",
        stagger: {
          each: 0.02,
          ease: "none",
          from: "end",
        },
      },
      0
    );
    return tl;
  },
});

gsap.registerEffect({
  name: "burnOut",
  extendTimeline: true,
  defaults: {
    y: 0,
    x: 0,
    duration: 0.3,
    ease: "none",
  },
  effect: (targets, config) => {
    gsap.set(targets, { filter: "blur(0px) brightness(1)" });
    let tl = gsap.timeline();
    tl.to(targets, {
      filter: "blur(30px) brightness(10)",
      scale: 0.3,
      rotation: 10,
      duration: config.duration,
      ease: config.ease,
      x: config.x,
      y: config.y,
      clearProps: "filter",
      stagger: {
        each: 0.01,
        ease: "none",
        from: "end",
      },
    });

    tl.to(
      targets,
      {
        duration: 0.1,
        opacity: 0,
        ease: "none",
        stagger: {
          each: 0.01,
          ease: "power2",
          from: "end",
        },
      },
      0
    );
    return tl;
  },
});

//animation fade button

gsap
  .timeline({
    scrollTrigger: {
      trigger: ".page",
      start: "top top",
      // endTrigger: ".sec3",
      pinSpacing: false,
      end: "+=230",
      // markers: true,
      pin: true,
      scrub: true,
      toggleActions: "restart none restart reset",
    },
  })
  .to(".btn", { opacity: 0 })
  .to(".sec0Text", { opacity: 0 }, "<")
  .to(".sec0H2Text", { opacity: 0 }, "<")
  //show progress circle
  .from("#circ-cont #svg", { opacity: 0, y: -50, ease: "back" }, "<-0.2");

//------------

//animation text 1

let split1 = new SplitText(".sec1Text");

gsap
  .timeline({
    scrollTrigger: {
      trigger: ".page",
      start: "top+=550px top",
      pinSpacing: false,
      end: "+=1300",
      // markers: true,
      pin: true,
      scrub: true,
      toggleActions: "restart none restart reset",
    },
  })
  .slideInUp(split1.chars, { y: 40, ease: "back" })
  .slideOutUp(split1.chars, { y: -100, duration: 0.2 });

//------------

//SECTION 2
let split2 = new SplitText(".sec2Text");

gsap
  .timeline({
    scrollTrigger: {
      trigger: ".page",
      start: "top+=900px top",
      pinSpacing: false,
      end: "+=1000",
      // markers: true,
      scrub: true,
      pin: true,
      toggleActions: "restart none restart reset",
    },
  })
  .slideInUp(split2.chars, { y: 40, ease: "back" })
  .slideOutUp(split2.chars, { y: -100, duration: 0.2 });

//SECTION 3

let split3 = new SplitText(".sec3Text");

gsap
  .timeline({
    scrollTrigger: {
      trigger: ".page",
      start: "top+=1350px top",
      pinSpacing: false,
      end: "+=1400",
      // markers: true,
      scrub: true,
      pin: true,
      toggleActions: "restart none restart reset",
    },
  })
  .burnIn(split3.chars, { x: -10 }, 0)
  .burnOut(split3.chars, { x: 50 }, "+=1");

//SECTION 4

let split4 = new SplitText(".sec4Text");

gsap
  .timeline({
    scrollTrigger: {
      trigger: ".page",
      start: "top+=1500px top",
      pinSpacing: false,
      end: "+=1800",
      // markers: true,
      scrub: true,
      pin: true,
      toggleActions: "restart none restart reset",
    },
  })
  .burnIn(split4.chars, { x: -10 }, 0)
  .burnOut(split4.chars, { x: 50 }, "+=2");

//SECTION 5

let split5 = new SplitText(".sec5Text");

gsap
  .timeline({
    scrollTrigger: {
      trigger: ".page",
      start: "top+=1690px top",
      pinSpacing: false,
      end: "+=2160",
      // markers: true,
      scrub: true,
      pin: true,
      toggleActions: "restart none restart reset",
    },
  })
  .from(split5.chars, {
    duration: 2,
    y: 20,
    rotation: 30,
    opacity: 0,
    ease: "elastic",
    stagger: {
      each: 0.04,
      from: "end",
      ease: "none",
    },
  })
  //exploding text...
  .to(
    split5.chars,
    {
      duration: 2.5,
      opacity: 0,
      rotation: "random(-2000, 2000)",
      physics2D: () => ({
        angle: "random(280, 320)",
        velocity: "random(300, 340)",
        gravity: 800,
      }),
      stagger: 0.045,
    },
    3
  );

//SECTION 6

let split6 = new SplitText(".sec6Text");

gsap
  .timeline({
    scrollTrigger: {
      trigger: ".page",
      start: "top+=2020px top",
      pinSpacing: false,
      end: "+=3530",
      // markers: true,
      scrub: true,
      pin: true,
      toggleActions: "restart none restart reset",
    },
  })
  .from(split6.chars, {
    duration: 2,
    y: 20,
    rotation: 30,
    opacity: 0,
    ease: "elastic",
    stagger: {
      each: 0.04,
      from: "end",
      ease: "none",
    },
  })
  //exploding text...
  .to(
    split6.chars,
    {
      duration: 1.5,
      opacity: 0,
      rotation: "random(-2000, 2000)",
      physics2D: () => ({
        angle: "random(240, 320)",
        velocity: "random(70, 150)",
        gravity: 800,
      }),
      stagger: 0,
    },
    3
  );

//SECTION 9

let split9 = new SplitText(".sec9Text");

gsap
  .timeline({
    scrollTrigger: {
      trigger: ".page",
      start: "top+=2320px top",
      pinSpacing: false,
      end: "+=2200",
      // markers: true,
      scrub: true,
      pin: true,
      toggleActions: "restart none restart reset",
    },
  })
  .from(split9.chars, {
    duration: 2,
    y: 20,
    rotation: 30,
    opacity: 0,
    ease: "elastic",
    stagger: {
      each: 0.04,
      from: "end",
      ease: "none",
    },
  })
  //exploding text...
  .to(
    split9.chars,
    {
      duration: 1.5,
      opacity: 0,
      rotation: "random(-2000, 2000)",
      physics2D: () => ({
        angle: "random(0, 310)",
        velocity: "random(300, 340)",
        gravity: 800,
      }),
      stagger: 0,
    },
    3
  );

//SECTION 7

let split7 = new SplitText(".sec7Text");

gsap
  .timeline({
    scrollTrigger: {
      trigger: ".page",
      start: "top+=2321px top",
      pinSpacing: false,
      end: "+=900",
      // markers: true,
      scrub: true,
      pin: true,
      toggleActions: "restart none restart reset",
    },
  })
  .from(split7.chars, {
    duration: 2,
    y: -40,
    rotation: 30,
    opacity: 0,
    ease: "back",
    stagger: {
      each: 0.04,
      from: "start",
      ease: "none",
    },
  })
  //exploding text...
  .to(
    split7.chars,
    {
      duration: 0.6,
      opacity: 0,
      rotation: "random(-2000, 2000)",
      physics2D: () => ({
        angle: "random(200, 280)",
        velocity: "random(300, 340)",
        gravity: 800,
      }),
      stagger: {
        each: 0.07,
        ease: "none",
        from: "end",
      },
    },
    3
  );

//SECTION 8

let split8 = new SplitText(".sec8Text");

gsap
  .timeline({
    scrollTrigger: {
      trigger: ".page",
      start: "top+=2950px top",
      pinSpacing: false,
      end: "+=2900",
      // markers: true,
      scrub: true,
      pin: true,
      toggleActions: "restart none restart reset",
    },
  })
  .from(split8.chars, {
    duration: 2,
    y: 20,
    rotation: 30,
    opacity: 0,
    ease: "elastic",
    stagger: {
      each: 0.04,
      from: "end",
      ease: "none",
    },
  })
  //exploding text...
  .to(
    split8.chars,
    {
      duration: 2.5,
      opacity: 0,
      rotation: "random(-2000, 2000)",
      physics2D: () => ({
        angle: "random(280, 320)",
        velocity: "random(300, 340)",
        gravity: 800,
      }),
      stagger: 0.055,
    },
    3
  );

//SECTION 10

let split10 = new SplitText(".sec10Text");

gsap
  .timeline({
    scrollTrigger: {
      trigger: ".page",
      start: "top+=3050px top",
      pinSpacing: false,
      end: "+=1550",
      // markers: true,
      pin: true,
      scrub: true,
      toggleActions: "restart none restart reset",
    },
  })
  .slideInUp(split10.chars, { y: 20, ease: "back" })
  .to(
    ".warpAmount",
    {
      autoAlpha: 1,
      innerText: 7912,
      duration: 3,
      snap: {
        innerText: 1,
      },
    },
    ">-0.7"
  )
  //exploding text...
  .to(split10.chars, {
    duration: 2.5,
    opacity: 0,
    scale: 1.2,
    rotation: "random(-2000, 2000)",
    physics2D: () => ({
      angle: "random(0, 360)",
      velocity: "random(300, 340)",
      gravity: 0,
    }),
    stagger: 0,
  })
  .to(
    ".warpAmount",
    {
      duration: 2.5,
      opacity: 0,
      scale: 1.2,
      rotation: "random(-2000, 2000)",
      physics2D: () => ({
        angle: "random(0, 360)",
        velocity: "random(300, 340)",
        gravity: 0,
      }),
      stagger: 0,
    },
    "<"
  )
  .to(".progress", { autoAlpha: 0 });

//THREE JS PART
// // --- SCENES OBJECT

const scenes = {
  scene0: new THREE.Scene(),
  scene1: new THREE.Scene(),
  scene2: new THREE.Scene(),
  scene3: new THREE.Scene(),
  scene4: new THREE.Scene(),
  scene5: new THREE.Scene(),
  scene6: new THREE.Scene(),
  scene7: new THREE.Scene(),
  scene8: new THREE.Scene(),
};

// --- COLORS OBJECT

const COLORS = {
  background: "white",
  light: "#ffffff",
  light2: "#ff0ff0",
  sky: "#aaaaff",
  ground: "#88ff88",
  blue: "steelblue",
  blue2: "blue",
};

//SCENES PROPERTIES:

// -SCENE0 --------------------------

// --- LIGHTS for scene0

const directionalLight = new THREE.DirectionalLight(COLORS.light, 3.5);
directionalLight.castShadow = true;
directionalLight.shadow.camera.far = 10;
directionalLight.shadow.mapSize.set(1024, 1024);
directionalLight.shadow.normalBias = 0.05;
directionalLight.position.set(2, 5, 3);

scenes.scene0.add(directionalLight);

const hemisphereLight = new THREE.HemisphereLight(
  COLORS.light,
  COLORS.blue,
  5.0
);
scenes.scene0.add(hemisphereLight);

// starfield on scene0:

let sphereBg;

const loader = new THREE.TextureLoader();

//with ./textures it loads the images:
const textureSphereBg = loader.load("./textures/space-original.jpg");
textureSphereBg.anisotropy = 160;
const geometrySphereBg = new THREE.SphereBufferGeometry(160, 32, 32);
const materialSphereBg = new THREE.MeshBasicMaterial({
  side: THREE.BackSide,
  map: textureSphereBg,
  fog: false,
});
sphereBg = new THREE.Mesh(geometrySphereBg, materialSphereBg);
sphereBg.position.set(0, 0, 0);

scenes.scene0.add(sphereBg);

/*   Star Lines values  */

//warp active variable
let active = false;

//creates the starfield for both normal and warp speed
let lineTotal = 1200;
let lineTotal_w = 8000;

let linesGeometry = new THREE.BufferGeometry();
let linesGeometry_w = new THREE.BufferGeometry();

linesGeometry.setAttribute(
  "position",
  new THREE.BufferAttribute(new Float32Array(6 * lineTotal), 3)
);
linesGeometry_w.setAttribute(
  "position",
  new THREE.BufferAttribute(new Float32Array(6 * lineTotal_w), 3)
);
linesGeometry.setAttribute(
  "velocity",
  new THREE.BufferAttribute(new Float32Array(2 * lineTotal), 1)
);
linesGeometry_w.setAttribute(
  "velocity",
  new THREE.BufferAttribute(new Float32Array(2 * lineTotal_w), 1)
);
let l_positionAttr = linesGeometry.getAttribute("position");
let l_positionAttr_w = linesGeometry_w.getAttribute("position");
let l_vertex_Array = linesGeometry.getAttribute("position").array;
let l_vertex_Array_w = linesGeometry_w.getAttribute("position").array;
let l_velocity_Array = linesGeometry.getAttribute("velocity").array;
let l_velocity_Array_w = linesGeometry_w.getAttribute("velocity").array;

//  Stars
for (let i = 0; i < lineTotal; i++) {
  let x = THREE.MathUtils.randInt(-100, 100);
  let y = THREE.MathUtils.randInt(-50, 50);
  if (x < 7 && x > -7 && y < 5 && y > -5) {
    x += 14;
    y += 14;
  }
  let z = THREE.MathUtils.randInt(0, -300);

  l_vertex_Array[6 * i + 0] = l_vertex_Array[6 * i + 3] = x;
  l_vertex_Array[6 * i + 1] = l_vertex_Array[6 * i + 4] = y;
  l_vertex_Array[6 * i + 2] = l_vertex_Array[6 * i + 5] = z;

  l_velocity_Array[2 * i] = l_velocity_Array[2 * i + 1] = 0;
}

//warp
for (let i = 0; i < lineTotal_w; i++) {
  let x_w = THREE.MathUtils.randInt(-100, 100);
  let y_w = THREE.MathUtils.randInt(-50, 50);
  if (x_w < 7 && x_w > -7 && y_w < 5 && y_w > -5) {
    x_w += 14;
    y_w += 14;
  }
  let z_w = THREE.MathUtils.randInt(0, -300);

  l_vertex_Array_w[6 * i + 0] = l_vertex_Array_w[6 * i + 3] = x_w;
  l_vertex_Array_w[6 * i + 1] = l_vertex_Array_w[6 * i + 4] = y_w;
  l_vertex_Array_w[6 * i + 2] = l_vertex_Array_w[6 * i + 5] = z_w;

  l_velocity_Array_w[2 * i] = l_velocity_Array_w[2 * i + 1] = 0;
}

let starsColor = "#ffffff";
let starsColor_w = "#1AFEFF";

let starsMaterial = new THREE.LineBasicMaterial({
  color: starsColor,
  transparent: true,
  opacity: 0.5,
  fog: false,
});

let starsMaterial_w = new THREE.LineBasicMaterial({
  color: starsColor_w,
  transparent: false,
  opacity: 1,
  fog: false,
});

let lines = new THREE.LineSegments(linesGeometry, starsMaterial);
let lines_w = new THREE.LineSegments(linesGeometry_w, starsMaterial_w);

linesGeometry.getAttribute("position").setUsage(THREE.DynamicDrawUsage);
linesGeometry_w.getAttribute("position").setUsage(THREE.DynamicDrawUsage);

scenes.scene0.add(lines);

scenes.scene0.add(lines_w);

const starsAnimation = () => {
  //   Stars Animation
  for (let i = 0; i < lineTotal; i++) {
    l_velocity_Array[2 * i] += 0.005;
    l_velocity_Array[2 * i + 1] += 0.0049;

    l_vertex_Array[6 * i + 2] += l_velocity_Array[2 * i];
    l_vertex_Array[6 * i + 5] += l_velocity_Array[2 * i + 1];

    //100 is the -z after passing
    if (l_vertex_Array[6 * i + 2] > 100) {
      l_vertex_Array[6 * i + 2] = l_vertex_Array[6 * i + 5] =
        THREE.MathUtils.randInt(-200, 10);
      l_velocity_Array[2 * i] = 0;
      l_velocity_Array[2 * i + 1] = 0;
    }
  }

  //enables stars animation:
  l_positionAttr.needsUpdate = true;

  //   Stars Animation WARP
  for (let i = 0; i < lineTotal_w; i++) {
    l_velocity_Array_w[2 * i] += 0.07;
    l_velocity_Array_w[2 * i + 1] += 0.065;

    l_vertex_Array_w[6 * i + 2] += l_velocity_Array_w[2 * i];
    l_vertex_Array_w[6 * i + 5] += l_velocity_Array_w[2 * i + 1];

    if (active) {
      if (l_vertex_Array_w[6 * i + 2] > 50) {
        l_vertex_Array_w[6 * i + 2] = l_vertex_Array_w[6 * i + 5] =
          THREE.MathUtils.randInt(-200, 10);
        l_velocity_Array_w[2 * i] = 0;
        l_velocity_Array_w[2 * i + 1] = 0;
      }
    }
  }

  //to avoid initial flash of warp
  setTimeout(() => {
    l_positionAttr_w.needsUpdate = true;
  }, 6000);

  //creates stars animation:
  window.requestAnimationFrame(() => starsAnimation());
};

starsAnimation();

// -SCENE1 --------------------------

const gridHelper1 = new THREE.GridHelper(1000, 100);
gridHelper1.position.z = 0;
gridHelper1.position.y = -50;
gridHelper1.rotateY(-Math.PI * 1);

scenes.scene1.add(gridHelper1);

const uniforms = {
  time: { value: 0.0 },
  speed: { value: 15.0 },
  charSize: { value: { x: 0.87, y: 0.93 } },
  charResolution: { value: 0.1 },
  color: { value: new THREE.Color(0, 0.7, 0.145) },
  resolution: { value: { x: 2, y: 2 } },
};
//in spite of the name, this is not a wire material:
const wireframeMaterial = new THREE.ShaderMaterial({
  uniforms: uniforms,
  vertexShader: vShader,
  fragmentShader: fShader,
});

scenes.scene1.overrideMaterial = wireframeMaterial;

scenes.scene1.background = new THREE.Color(0x04070d);

const gridHelper2 = new THREE.GridHelper(1000, 100);
gridHelper2.position.z = 0;
gridHelper2.position.y = -50;
gridHelper2.rotateY(-Math.PI * 1);

scenes.scene2.add(gridHelper2);

// -SCENE2 --------------------------

const uniforms1 = {
  time: { value: 0.0 },
  color: {
    value: new THREE.Color(
      0.14901960784313725,
      0.2784313725490196,
      0.9882352941176471
    ),
  },
  uvScale: { value: { x: 0.7, y: 0.7 } },
  brightness: { value: 22.0 },
  speed: { value: 0.02 },
};

const wireframeMaterial2 = new THREE.ShaderMaterial({
  uniforms: uniforms1,
  vertexShader: vShader1,
  fragmentShader: fShader1,
});

scenes.scene2.overrideMaterial = wireframeMaterial2;

scenes.scene2.background = new THREE.Color(0x343741);

// -SCENE3 --------------------------

const gridHelper3 = new THREE.GridHelper(1000, 100);
gridHelper3.position.z = 0;
gridHelper3.position.y = -50;
gridHelper3.rotateY(-Math.PI * 1);

scenes.scene3.add(gridHelper3);

scenes.scene3.background = new THREE.Color(0x7c7c86);

const uniforms3 = {
  time: { value: 0.0 },
  displacement: { value: 0 },
  scale: { value: 10 },
  speed: { value: 1 },
  color: {
    value: new THREE.Color(0.25, 1.125, 1.713),
  },
};

const wireframeMaterial3 = new THREE.ShaderMaterial({
  uniforms: uniforms3,
  vertexShader: vShader3,
  fragmentShader: fShader3,
});

scenes.scene3.overrideMaterial = wireframeMaterial3;

// -SCENE4 --------------------------

// background scene4
scenes.scene4.background = new THREE.Color(0x242324);

const uniforms4 = {
  time: { value: 0.0 },
  displacement: { value: 10 },
  scale: { value: 10 },
  speed: { value: 1 },
  color: {
    value: new THREE.Color(0.75, 0.05, 0.713),
  },
};

const wireframeMaterial4 = new THREE.ShaderMaterial({
  uniforms: uniforms4,
  vertexShader: vShader4,
  fragmentShader: fShader4,
  wireframe: true,
});

scenes.scene4.overrideMaterial = wireframeMaterial4;

// -SCENE 5 --------------------------

const gridHelper5 = new THREE.GridHelper(1000, 100);
gridHelper5.position.z = 0;
gridHelper5.position.y = -50;
gridHelper5.rotateY(-Math.PI * 1);

scenes.scene5.add(gridHelper5);

const uniforms5 = {
  time: { value: 0.0 },
  frequency: { value: 0.6 },
  amplitude: { value: 1 },
  color: {
    value: new THREE.Color(0.25, 0.125, 0.713),
  },
};

const wireframeMaterial5 = new THREE.ShaderMaterial({
  uniforms: uniforms5,
  vertexShader: vShader4,
  fragmentShader: fShader4,
});

scenes.scene5.overrideMaterial = wireframeMaterial5;

scenes.scene5.background = new THREE.Color(0x343741);

// -SCENE 6 --------------------------

const gridHelper6 = new THREE.GridHelper(1000, 100);
gridHelper6.position.z = 0;
gridHelper6.position.y = -50;
gridHelper6.rotateY(-Math.PI * 1);

scenes.scene6.add(gridHelper6);

const uniforms6 = {
  time: { value: 0.0 },
  resolution: { value: 40.0 },
  intensity: { value: 10.0 },
  speed: { value: 1.5 },
  lightColor: {
    value: new THREE.Color(150, 0.964, 0.149),
  },
  baseColor: { value: new THREE.Color(0.6, 0.6, 0.6) },
};

const wireframeMaterial6 = new THREE.ShaderMaterial({
  uniforms: uniforms6,
  vertexShader: vShader5,
  fragmentShader: fShader5,
});

scenes.scene6.overrideMaterial = wireframeMaterial6;

scenes.scene6.background = new THREE.Color(0x7c7c86);

// -SCENE 7 --------------------------

const gridHelper7 = new THREE.GridHelper(1000, 100);
gridHelper7.position.z = 0;
gridHelper7.position.y = -50;
gridHelper7.rotateY(-Math.PI * 1);

scenes.scene7.add(gridHelper7);
scenes.scene7.background = new THREE.Color(0x04070d);

const uniforms7 = {
  time: { value: 0.0 },
  zoom: { value: 1 },
};

const wireframeMaterial7 = new THREE.ShaderMaterial({
  uniforms: uniforms7,
  vertexShader: vShader6,
  fragmentShader: fShader6,
});

scenes.scene7.overrideMaterial = wireframeMaterial7;

// -SCENE 8 --------------------------

scenes.scene8.background = new THREE.Color(0x242324);

const uniforms8 = {
  time: { value: 0.0 },
  zoom: { value: 100 },
};

const wireframeMaterial8 = new THREE.ShaderMaterial({
  uniforms: uniforms8,
  vertexShader: vShader6,
  fragmentShader: fShader6,
  wireframe: true,
});

scenes.scene8.overrideMaterial = wireframeMaterial8;

// ------------------------------------
// END OF SCENES DEFINITION
//--------------------------------------------

let pageSize = { pageWidth: 0, pageHeight: 0 };

//views object, with scenes, cameras and viewport parameters as variables:

const views = [
  {
    heightStartView: 0,
    heightEndView: 1,
    widthStartView: 0,
    widthEndView: 1,
    scene: scenes.scene0,
    camera: null,
  },
  {
    heightStartView: 0,
    heightEndView: 1,
    widthStartView: 1,
    widthEndView: 1,
    scene: scenes.scene1,
    camera: null,
  },
  {
    heightStartView: 0,
    heightEndView: 1,
    widthStartView: 1,
    widthEndView: 1,
    scene: scenes.scene2,
    camera: null,
  },
  {
    heightStartView: 0,
    heightEndView: 0,
    widthStartView: 0,
    widthEndView: 1,
    scene: scenes.scene3,
    camera: null,
  },
  {
    heightStartView: 0,
    heightEndView: 1,
    widthStartView: 0,
    widthEndView: 0,
    scene: scenes.scene4,
    camera: null,
  },
  {
    heightStartView: 0,
    heightEndView: 1,
    widthStartView: 1,
    widthEndView: 1,
    scene: scenes.scene5,
    camera: null,
  },
  {
    heightStartView: 1,
    heightEndView: 1,
    widthStartView: 0,
    widthEndView: 1,
    scene: scenes.scene6,
    camera: null,
  },
  {
    heightStartView: 0,
    heightEndView: 0,
    widthStartView: 0,
    widthEndView: 1,
    scene: scenes.scene7,
    camera: null,
  },
  {
    heightStartView: 0,
    heightEndView: 1,
    widthStartView: 1,
    widthEndView: 1,
    scene: scenes.scene8,
    camera: null,
  },
];

//axes visualization option:
// const axesHelper = new THREE.AxesHelper(5);
// views[0].scene.add(axesHelper);

// --- RENDERER

const renderer = new THREE.WebGLRenderer({
  antialias: true,
  alpha: true,
});
//render parameters:

renderer.physicallyCorrectLights = true;
//desabled to avoid pixelated view on universe sphere:
// renderer.outputEncoding = THREE.sRGBEncoding;
// renderer.toneMappingExposure = 5;
//---------------------
renderer.toneMapping = THREE.ReinhardToneMapping;
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;

//adding render to canvas:
const container = document.querySelector(".canvas-container");
container.appendChild(renderer.domElement);

// --- CAMERA

//removed to avoir error:
// camera.position.set(0, 1, 32);

let cameraTarget = new THREE.Vector3(0, 0, 0);

//adding camera to each view
views.forEach((view) => {
  view.camera = new THREE.PerspectiveCamera(
    55,
    pageSize.pageWidth / pageSize.pageHeight,
    1,
    1000
  );

  //orbit controls:
  // const controls = new OrbitControls(view.camera, renderer.domElement);
  // controls.update();
  // controls.addEventListener("change", () => {
  //   console.log(controls.object.position);
  // });

  view.camera.position.set(10, 5, 36);
  view.camera.rotation.set(new THREE.Euler(0, 10, 1.57, "XYZ"));
  view.scene.add(view.camera);
});

const clock = new THREE.Clock();

const tick = () => {
  //times for shaders ------------
  uniforms.time.value = clock.getElapsedTime();
  uniforms1.time.value = clock.getElapsedTime();
  uniforms3.time.value = clock.getElapsedTime();
  uniforms4.time.value = clock.getElapsedTime();
  uniforms5.time.value = clock.getElapsedTime();
  uniforms6.time.value = clock.getElapsedTime();
  uniforms7.time.value = clock.getElapsedTime() / 2;
  uniforms8.time.value = clock.getElapsedTime() / 3;

  //--------

  sphereBg.rotation.x += active ? 0.0001 : 0.0003;
  sphereBg.rotation.y += 0.00003;

  views.forEach((view) => {
    view.camera.lookAt(cameraTarget);
    //height viewport top and bottom cuts:
    let heightStartViewPixels = pageSize.pageHeight * view.heightStartView;
    let heightEndViewPixels = pageSize.pageHeight * view.heightEndView;
    //width viewport left and right cuts:
    let widthStartViewPixels = pageSize.pageWidth * view.widthStartView;
    let widthEndViewPixels = pageSize.pageWidth * view.widthEndView;
    //defining viewport size and scissor for each view:
    renderer.setViewport(0, 0, pageSize.pageWidth, pageSize.pageHeight);
    renderer.setScissor(
      widthStartViewPixels,
      heightStartViewPixels,
      widthEndViewPixels,
      heightEndViewPixels
    );

    renderer.setScissorTest(true);
    renderer.render(view.scene, view.camera);
  });

  window.requestAnimationFrame(() => tick());
};

tick();

//objects for animating multiple models and clones:

//original models object
const models = {};

//object clones for each scene:
const clones1 = {};
const clones2 = {};
const clones3 = {};
const clones4 = {};
const clones5 = {};
const clones6 = {};
const clones7 = {};
const clones8 = {};

//handle models and clones cameras, to animate them all with gsap
let cameras = null;

//handle models and clones, to animate them all with gsap
let modelsAndClones = null;

//loading and hiding spinner
const hideLoading = () => {
  gsap.to(".loading", { y: "-150%", ease: "power4.in", duration: 0.4 });
};

const setupAnimation = () => {
  hideLoading();

  cameras = {
    position: [
      views[0].camera.position,
      views[1].camera.position,
      views[2].camera.position,
      views[3].camera.position,
      views[4].camera.position,
      views[5].camera.position,
      views[6].camera.position,
      views[7].camera.position,
      views[8].camera.position,
    ],
    rotation: [
      views[0].camera.rotation,
      views[1].camera.rotation,
      views[2].camera.rotation,
      views[3].camera.rotation,
      views[4].camera.rotation,
      views[5].camera.rotation,
      views[6].camera.rotation,
      views[7].camera.rotation,
      views[8].camera.rotation,
    ],
  };
  modelsAndClones = {
    position: [
      models.model1.position,
      clones1.model1.position,
      clones2.model1.position,
      clones3.model1.position,
      clones4.model1.position,
      clones5.model1.position,
      clones6.model1.position,
      clones7.model1.position,
      clones8.model1.position,
    ],
    rotation: [
      models.model1.rotation,
      clones1.model1.rotation,
      clones2.model1.rotation,
      clones3.model1.rotation,
      clones4.model1.rotation,
      clones5.model1.rotation,
      clones6.model1.rotation,
      clones7.model1.rotation,
      clones8.model1.rotation,
    ],
    scale: [
      models.model1.scale,
      clones1.model1.scale,
      clones2.model1.scale,
      clones3.model1.scale,
      clones4.model1.scale,
      clones5.model1.scale,
      clones6.model1.scale,
      clones7.model1.scale,
      clones8.model1.scale,
    ],
  };

  //setting initial satate for animations:
  gsap.set(modelsAndClones.position, { x: 0, z: -5 });
  gsap.set(modelsAndClones.rotation, { y: Math.PI * 1 });
  gsap.set("#circ-cont #svg", {
    scale: 0.2,
    autoAlpha: 1,
    rotate: -90,
  });
  gsap.set(".autoPilotBTN", { autoAlpha: 1 });
  gsap.set(".contact", { autoAlpha: 1 });

  gsap.set(".sec10Text", { autoAlpha: 1 });
  //avoit fouc:
  gsap.set(".warpAmount", { autoAlpha: 0 });

  // creates the scrollSmoother before the scrollTriggers
  ScrollSmoother.create({
    smooth: 1.5, // how long (in seconds) it takes to "catch up" to the native scroll position
    effects: true, // looks for data-speed and data-lag attributes on elements
    smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
  });

  ScrollTrigger.matchMedia({
    "(prefers-reduced-motion: no-preference)": desktopAnimation,
  });
};

const desktopAnimation = () => {
  const tl = gsap.timeline({
    default: {
      duration: 10,
      ease: "none",
    },
    scrollTrigger: {
      trigger: "body",
      start: "top 0%",
      end: "bottom 100%",
      scrub: 1.1,
      // markers: false,
      onUpdate: (self) => {
        gsap.to("#circ-cont #svg circle", {
          strokeDashoffset: () => 753.98 - self.progress * 753.98,
        });
        if (self.progress >= 0.94) {
          active = true;
        } else {
          active = false;
        }
        //restart button logic
        if (self.progress >= 0.99) {
          restartBTN.style.visibility = "visible";
          autoPilotBTN.style.visibility = "hidden";
          stopAutoBTN.style.visibility = "hidden";
        } else {
          restartBTN.style.visibility = "hidden";
        }
        //solution to the problem of visibility on restart button after end
        if (self.progress <= 0.99 && self.progress >= 0.986) {
          autoPilotBTN.style.visibility = "visible";
        }
      },
    },
  });

  gsap.timeline().from(".sec0", { autoAlpha: 0 });

  let split0 = new SplitText(".sec0Text", { type: "chars,words,lines" });

  gsap.timeline().slideInUp(split0.chars, { y: 40, ease: "back" });

  let split0h2 = new SplitText(".sec0H2Text", { type: "chars,words,lines" });

  gsap.timeline().slideInUp(split0h2.chars, { y: 40, ease: "back" });

  //scroll down button animation
  gsap
    .timeline()
    .from(".btn", {
      autoAlpha: 0,
    })
    .from(".btnWrapper", {
      x: -200,
      opacity: 0,
      rotation: 60,
      opacity: 0,
      ease: "back",
      duration: 2,
    });

  //spacecraft initial animation:
  gsap.from(
    modelsAndClones.position,
    { z: -120, duration: 4, ease: "back" },
    0
  );
  gsap.from(
    modelsAndClones.scale,
    { x: 0, y: 0, z: 0, duration: 4, ease: "back" },
    0
  );

  gsap.from(
    modelsAndClones.rotation,
    { y: Math.PI * 0.75, duration: 3, ease: "back" },
    0
  );
  //end of spacecraft initial animation:

  gsap.from(
    ".autoPilotBTN",
    { opacity: 0, x: 300, rotate: 20, ease: "back", duration: 2 },
    1
  );
  gsap.from(
    ".contact",
    { opacity: 0, x: -200, rotate: 20, ease: "back", duration: 2 },
    1
  );

  //main on-scroll animations:

  tl.to(cameras.position, { x: 8.95, y: -4.5, z: -16.67 }, 0)
    .to(modelsAndClones.rotation, { z: -Math.PI * 2 }, "<")

    .to(cameras.position, { x: -20, y: -6.5, z: 12 })
    .to(cameras.position, { x: 0, y: 2, z: 24 })
    .to(cameras.position, { x: 28, y: 0, z: 1 })
    .to(modelsAndClones.rotation, { z: -Math.PI * 1.5 }, "<")
    .to(cameras.position, { x: 28, y: 0, z: 1 })

    //scene 1
    .to(views[1], { widthStartView: 0, ease: "none" }, "<")
    .to(modelsAndClones.rotation, { z: Math.PI * 0.5 }, "<")

    .to(cameras.position, { x: 3.2, y: -15.4, z: -0.05 })

    //scene 2
    .to(views[2], { widthStartView: 0, ease: "none" })
    .to(cameras.position, { x: 25.72, y: 0.15, z: 0.11 })

    .to(views[3], { heightEndView: 1, ease: "none" })
    .to(cameras.position, { x: -1.05, y: -0.85, z: -15.65 })
    .to(modelsAndClones.rotation, { z: 0 }, "<")
    .to(views[4], { widthEndView: 1, ease: "none" })
    .to(cameras.position, { x: 16.43, y: -4.24, z: -6.89 })
    .to(views[5], { widthStartView: 0, ease: "none" })
    .to(cameras.position, { x: 11.16, y: 14.51, z: -0.31 })
    .to(cameras.position, { x: 4.15, y: 1.3, z: 20.9 })
    .to(views[6], { heightStartView: 0, ease: "none" })
    .to(cameras.position, { x: 13.66, y: 2.75, z: -2.5 })
    .to(cameras.position, { x: 1.7, y: 24.15, z: -0.01 })
    .to(views[7], { heightEndView: 1, ease: "none" })
    .to(cameras.position, { x: 15.5, y: -3.86, z: -2.28 })
    .to(views[8], { widthStartView: 0, ease: "none" })
    .to(cameras.position, { x: -0.2, y: -2.36, z: 18 })
    .to(cameras.position, { x: 6.99, y: 18.18, z: 0.08 })

    //comes back to scene0
    .to(views[7], { heightEndView: 0, ease: "none" }, "<")
    .to(views[6], { heightStartView: 1, ease: "none" }, "<")
    .to(views[5], { widthStartView: 1, ease: "none" }, "<")
    .to(views[4], { widthEndView: 0, ease: "none" }, "<")
    .to(views[3], { heightEndView: 0, ease: "none" }, "<")
    .to(views[2], { widthStartView: 1, ease: "none" }, "<")
    .to(views[1], { widthStartView: 1, ease: "none" }, "<")
    .to(views[8], { widthStartView: 1, ease: "none" })
    .to(modelsAndClones.rotation, { z: -Math.PI * 2 }, "<")

    // end of scene0
    .to(cameras.position, { x: 10.79, y: 3.97, z: 28.34 })
    .to(cameras.position, { x: 0.19, y: 0.21, z: 20 })
    .to(modelsAndClones.position, { z: -800 }, "+=1")
    .to(modelsAndClones.scale, { x: 0, y: 0, z: 0 }, "<");
};

//3d models loading process:
const LoadingManager = new THREE.LoadingManager(() => {
  setupAnimation();
});

const gltfLoader = new GLTFLoader(LoadingManager);

//in this case only one model:
const toLoad = [
  {
    name: "model1",
    points: [
      {
        position: new THREE.Vector3(0, 1, 1),
        element: "#model1",
      },
    ],
    group: new THREE.Group(),
    file: "./ENTREPRISE/scene.gltf",
  },
];

toLoad.forEach((item) => {
  gltfLoader.load(item.file, (model) => {
    model.scene.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        //only if shadows are needed:
        child.receiveShadow = true;
        child.castShadow = true;
      }
    });

    item.group.add(model.scene);
    scenes.scene0.add(item.group);
    models[item.name] = item.group;
    //the group is cloned and added to the each scene

    const clone1 = item.group.clone();
    clones1[item.name] = clone1;
    scenes.scene1.add(clone1);

    const clone2 = item.group.clone();
    clones2[item.name] = clone2;
    scenes.scene2.add(clone2);

    const clone3 = item.group.clone();
    clones3[item.name] = clone3;
    scenes.scene3.add(clone3);

    const clone4 = item.group.clone();
    clones4[item.name] = clone4;
    scenes.scene4.add(clone4);

    const clone5 = item.group.clone();
    clones5[item.name] = clone5;
    scenes.scene5.add(clone5);

    const clone6 = item.group.clone();
    clones6[item.name] = clone6;
    scenes.scene6.add(clone6);

    const clone7 = item.group.clone();
    clones7[item.name] = clone7;
    scenes.scene7.add(clone7);

    const clone8 = item.group.clone();
    clones8[item.name] = clone8;
    scenes.scene8.add(clone8);
  });
});

// --- ON RESIZE
const onResize = () => {
  pageSize.pageWidth = container.clientWidth;
  pageSize.pageHeight = container.clientHeight;

  let aspectRatio = pageSize.pageWidth / pageSize.pageHeight;

  views.forEach((view) => {
    view.camera.aspect = pageSize.pageWidth / pageSize.pageHeight;

    //custom made exponential curve to change camera fov on resize depending of aspect ratio:
    view.camera.fov =
      -3.4446 * Math.pow(aspectRatio, 3) +
      34.101 * Math.pow(aspectRatio, 2) -
      111.33 * aspectRatio +
      175.06;

    view.camera.updateProjectionMatrix();
  });

  renderer.setSize(pageSize.pageWidth, pageSize.pageHeight);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
};

window.addEventListener("resize", onResize);
onResize();

window.addEventListener("load", onResize);
